type ComparableSearchParams = Record<string, string | string[]>

export const compareSearchParamsEquality = (
  paramsA: ComparableSearchParams,
  paramsB: ComparableSearchParams
): boolean => {
  const keys1 = Object.keys(paramsA).sort()
  const keys2 = Object.keys(paramsB).sort()

  if (keys1.length !== keys2.length) return false
  if (keys1.join(',') !== keys2.join(',')) return false

  for (const key of keys1) {
    const value1 = paramsA[key]
    const value2 = paramsB[key]

    if (Array.isArray(value1) && Array.isArray(value2)) {
      if (value1.length !== value2.length) return false
      const sorted1 = [...value1].sort()
      const sorted2 = [...value2].sort()
      if (sorted1.join(',') !== sorted2.join(',')) return false
    } else if (value1 !== value2) {
      return false
    }
  }

  return true
}
